import { defineComponent as _defineComponent } from 'vue'
import BCXConfirm from '@/components/molecules/BCXConfirm.vue';
import { ref } from 'vue';

import MarvinAlarm from '@/components/svg/marvin/marvin_alarm.svg?inline';
import MarvinHappy from '@/components/svg/marvin/marvin_happy.svg?inline';

import useContract from '@/views/my-projects/composables/useContract';
import useI18n from '@/mixins/useI18n';
import useBCXConfirm from '@/mixins/useBCXConfirm';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectContractConfirms',
  setup(__props) {

const { onConfirm, showConfirm, ask } = useBCXConfirm();
const {
  events, abortContractProcess, finalizeContractProcess, reopenContractProcess, deleteContractProcess, openChatWithContractPartner
} = useContract();
const { t } = useI18n();

const okType = ref('warning');
const yesLabel = ref('yes');
const confirmText = ref('');
const justConfirmButton = ref(false);
const marvin = ref < any >(null);

const abortContract = () => {
  abortContractProcess();
};

const finalizeContract = () => {
  finalizeContractProcess();
};

const reopenContract = () => {
  reopenContractProcess();
};

const deleteContract = () => {
  deleteContractProcess();
};

events.on(async (evt) => {
  switch (evt) {
    case 'abort-contract':
      okType.value = 'warning';
      yesLabel.value = `${t('contracts.actions.confirms.abort')}`;
      confirmText.value = `${t('contracts.actions.confirm-texts.abort')}`;
      marvin.value = MarvinAlarm;
      justConfirmButton.value = false;
      if (await ask()) abortContract();
      break;
    case 'finalize-contract':
      okType.value = 'ok';
      yesLabel.value = `${t('contracts.actions.confirms.finalize')}`;
      confirmText.value = `${t('contracts.actions.confirm-texts.finalize')}`;
      marvin.value = MarvinHappy;
      justConfirmButton.value = false;
      if (await ask()) finalizeContract();
      break;
    case 'reopen-contract':
      okType.value = 'ok';
      yesLabel.value = `${t('contracts.actions.confirms.reopen')}`;
      confirmText.value = `${t('contracts.actions.confirm-texts.reopen')}`;
      marvin.value = MarvinHappy;
      justConfirmButton.value = false;
      if (await ask()) reopenContract();
      break;
    case 'delete-contract':
      okType.value = 'warning';
      yesLabel.value = `${t('contracts.actions.confirms.delete')}`;
      confirmText.value = `${t('contracts.actions.confirm-texts.delete')}`;
      marvin.value = MarvinAlarm;
      justConfirmButton.value = false;
      if (await ask()) deleteContract();
      break;
    case 'file-has-been-seen':
      okType.value = 'primary';
      yesLabel.value = `${t('contracts.contract.contractDocuments.details.buttons.ok')}`;
      confirmText.value = `${t('contracts.contract.contractDocuments.details.confirm-texts.file-is-downloaded')}`;
      justConfirmButton.value = true;
      marvin.value = MarvinHappy;
      await ask();
      break;
    case 'open-chat':
      await openChatWithContractPartner();
  }
});


return { __sfc: true,onConfirm, showConfirm, ask, events, abortContractProcess, finalizeContractProcess, reopenContractProcess, deleteContractProcess, openChatWithContractPartner, t, okType, yesLabel, confirmText, justConfirmButton, marvin, abortContract, finalizeContract, reopenContract, deleteContract, BCXConfirm, BCXMarkdown }
}

})